import React from 'react';
import { Link } from 'react-scroll';
import type { ReactScrollLinkProps } from 'react-scroll/modules/components/Link';
import { Box, Tab, Tabs } from '@mui/material';

import { ReactComponent as CheckCircleFilled } from 'assets/images/check-circle-filled-icon.svg';
import { ReactComponent as CheckCircle } from 'assets/images/check-circle-icon.svg';
import { TabLabel } from '..';

export interface ScrollTab {
  id: string;
  label: string;
  isComplete: boolean;
  informational?: boolean;
}

interface Props {
  containerId: string;
  setTitle?: (title: string) => void;
  tabs: ScrollTab[];
}

export const TabScrollNavigation: React.FC<Props> = (props) => {
  const [activeTab, setActiveTab] = React.useState(0);

  return (
    <Tabs
      TabIndicatorProps={{
        style: {
          display: 'none'
        }
      }}
      value={activeTab}
    >
      {props.tabs.map((t, i) => {
        return (
          <Tab
            disableRipple
            key={t.id}
            data-cy={`${t.id}-tab`}
            label={
              <TabLabel
                icon={
                  t.isComplete ? (
                    <CheckCircleFilled height="20px" width="20px" />
                  ) : (
                    <CheckCircle height="20px" width="20px" />
                  )
                }
                title={t.label}
              />
            }
            component={React.forwardRef((props: ReactScrollLinkProps, ref: React.ForwardedRef<unknown>) => (
              <Box ref={ref}>
                <Link {...props} />
              </Box>
            ))}
            containerId={props.containerId}
            duration={300}
            onSetActive={() => {
              setActiveTab(i);

              if (props.setTitle) {
                props.setTitle(t.label);
              }
            }}
            smooth={true}
            spy={true}
            to={t.id}
            sx={{
              textTransform: 'none',
              color: 'text.secondary',
              fontWeight: 'fontWeightRegular',
              mr: 1,
              padding: '0',
              display: 'flex',
              alignItems: 'center',
              '&.MuiTab-root': {
                minHeight: 0,
                minWidth: 0,
                padding: '5px 12px',
                border: '1px solid transparent'
              },
              '&.Mui-selected': {
                opacity: 1,
                backgroundColor: 'primary.light',
                borderColor: 'primary.main',
                borderRadius: 25,
                color: 'primary.main',
                fontWeight: 700
              },
              '&:hover': {
                color: 'primary.main'
              },
              '& > .MuiBox-root': {
                padding: '0'
              }
            }}
          />
        );
      })}
    </Tabs>
  );
};
